import { Fragment, ReactElement } from 'react';
import PersonSipoNonResidentSearchPage from 'mutation/pages/registration-civil-union/non-resident/edit-person-search';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import { RegistrationCivilUnionFormVM } from 'mutation/view-models/registration-civil-union';

interface PersonSearchCivilUnionNonResidentNotificationSharedProps {
  goBackUrl?: string;
  redirectUrl?: string;
  items?: BreadcrumbItem[];
  initialValues?: RegistrationCivilUnionFormVM;
}

const PersonSearchCivilUnionNonResidentNotificationShared = ({
  items,
  redirectUrl,
  goBackUrl,
  initialValues,
}: PersonSearchCivilUnionNonResidentNotificationSharedProps): ReactElement => {
  return (
    <Fragment>
      <PersonSipoNonResidentSearchPage
        redirectUrl={redirectUrl}
        goBackUrl={goBackUrl}
        breadcrumbItems={items}
        initialValues={initialValues}
      />
    </Fragment>
  );
};

PersonSearchCivilUnionNonResidentNotificationShared.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default PersonSearchCivilUnionNonResidentNotificationShared;
